import { render, staticRenderFns } from "./AddCollCustomer_mobile.vue?vue&type=template&id=374fd94f&scoped=true"
import script from "./AddCollCustomer_mobile.vue?vue&type=script&lang=js"
export * from "./AddCollCustomer_mobile.vue?vue&type=script&lang=js"
import style0 from "./AddCollCustomer_mobile.vue?vue&type=style&index=0&id=374fd94f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374fd94f",
  null
  
)

export default component.exports